module.exports = __webpack_public_path__ + "img/dashboard.6f1cc174.svg";